import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/site";

export const Manifesto = () => (
  <section id="promise" className="bg-[#1E1A17] py-24 md:py-32 text-[#F9F6F0]">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-2xl mb-16 md:mb-24">
        <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-[#E28721] font-semibold mb-4">Our Promise</p>
        <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl tracking-tight leading-none">
          The way it was <span className="italic text-[#F0C27B]">always meant</span> to be made.
        </h2>
      </div>

      <div className="divide-y divide-[#3D352F] border-t border-[#3D352F]">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: i * 0.05 }}
            className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-12 items-start group"
            data-testid={`manifesto-item-${m.n}`}
          >
            <div className="col-span-12 md:col-span-3">
              <span className="font-serif text-6xl md:text-8xl text-[#3D352F] group-hover:text-[#B83A14] transition-colors duration-500">
                {m.n}
              </span>
            </div>
            <h3 className="col-span-12 md:col-span-4 font-serif text-2xl md:text-3xl text-[#F9F6F0]">{m.title}</h3>
            <p className="col-span-12 md:col-span-5 text-[#B4A79A] text-base md:text-lg leading-relaxed">{m.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
